"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePasswordWidget = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var send_reset_password_link_1 = require("../../../api/calls/user/authentication/send_reset_password_link");
var ProfilePasswordWidget = function (props) {
    var _a = props;
    var cookie = new universal_cookie_1.default();
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_1.useState)(false), isEditing = _b[0], setIsEditing = _b[1];
    var _c = (0, react_1.useState)(false), isSaving = _c[0], setIsSaving = _c[1];
    var _d = (0, react_1.useState)(""), errorText = _d[0], setErrorText = _d[1];
    var _e = (0, react_1.useState)(""), successText = _e[0], setSuccessText = _e[1];
    var clearMessages = function () {
        setErrorText("");
        setSuccessText("");
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4  rounded-lg" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "flex-1" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Password", size: "large", textColor: "text-black" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-4" },
                !isEditing && (react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: isEditing ? pro_solid_svg_icons_1.faSave : pro_solid_svg_icons_1.faPen, backgroundColor: isEditing ? "bg-success" : "bg-primary", iconColor: "text-white", size: "xsmall", loading: isSaving, onClick: function () {
                        if (isEditing) {
                            setIsSaving(false);
                        }
                        else {
                            setIsEditing(true);
                        }
                    } })),
                isEditing && (react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_solid_svg_icons_1.faClose, backgroundColor: "bg-primary", iconColor: "text-white", size: "xsmall", onClick: function () {
                        clearMessages();
                        setIsEditing(false);
                    } })))),
        isEditing ? (react_1.default.createElement("div", { className: "flex flex-row gap-4" },
            react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" }, isEditing && (react_1.default.createElement(doshx_controls_web_1.ButtonControl
            //={isEditing ? faSave : faPen}
            , { 
                //={isEditing ? faSave : faPen}
                backgroundColor: "bg-success", iconColor: "text-white", size: "xsmall", loading: isSaving, enabled: !isSaving, textColor: "text-white", label: "Send Password Reset Link", onClick: function () {
                    setIsSaving(true);
                    (0, send_reset_password_link_1.send_reset_password_link)({ email: user === null || user === void 0 ? void 0 : user.email }).then(function (response) {
                        if (response.success) {
                            setSuccessText(response.message);
                            setIsSaving(response.content.is_loading);
                            setIsEditing(false);
                        }
                        else {
                            setErrorText(response.message);
                            setIsSaving(response.content.is_loading);
                            setIsEditing(false);
                        }
                    });
                } }))))) : (react_1.default.createElement("div", { className: "flex flex-col justify-center gap-4" },
            react_1.default.createElement("div", { className: "flex gap-1" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: successText, size: "xsmall", textColor: "text-success" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: errorText, size: "xsmall", textColor: "text-red-500" })),
            react_1.default.createElement("div", { className: "h-12 p-3 flex flex-row gap-4 bg-white rounded-lg justify-start items-center cursor-pointer shadow-md", onClick: function () {
                    setIsEditing(true);
                } },
                react_1.default.createElement("span", { className: " text-secondary " },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faShield })),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Edit Password", textColor: "text-black" }))))));
};
exports.ProfilePasswordWidget = ProfilePasswordWidget;
